import { func } from "prop-types";

export const commonFilterFormPropTypes = {
  updateFilter: func,
};
